import { Container } from '@/components/ui/container'
import { CheckCircleIcon } from '@/components/ui/icons'
import { PhotosetStatusMessage } from '@/features/photoset/components/photoset-status-message/photoset-status-message'
import { useTranslation } from '@/translations/i18n'

export const PhotosetEditingQaCompletedStep = () => {
	const { t } = useTranslation()

	return (
		<Container className='flex flex-col items-center justify-center'>
			<CheckCircleIcon
				className='fill-success-600'
				height={48}
				width={48}
			/>
			<PhotosetStatusMessage>
				<h1 className='font-bold text-display-xs text-neutral-900'>
					{t('photoset:editingQaCompleted.title')}
				</h1>
				<p className='text-neutral-900 text-xl'>
					{t('photoset:editingQaCompleted.subtitle')}
				</p>
			</PhotosetStatusMessage>
		</Container>
	)
}

PhotosetEditingQaCompletedStep.displayName = 'PhotosetEditingQaCompletedStep'
